import { render } from "./addUniverslQuote.vue?vue&type=template&id=38953d66"
import script from "./addUniverslQuote.vue?vue&type=script&lang=js"
export * from "./addUniverslQuote.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__